export const EQUIPMENT_PAGINATION_LIMIT = 12;
export const EQUIPMENT_RESULTS_LIMIT = 24;
